import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  // Comercial
  comercial_oportunities: any
  comercial_leads_by_state: any
  comercial_kw_install: any
  comercial_installation_completed: any
  comercial_coords_lead: any
  comercial_installations_in_progress: any;
  comercial_installations_in_sales_procces: any;
  comercial_name1: any
  comercial_name2: any
  comercial_name3: any
  comercial_name4: any
  comercial_name5: any
  comercial_name6: any
  comercial_kwsQuotations: any
  comercial_kwsInstallations: any
  comercial_kw1: any
  comercial_kw2: any
  comercial_kw3: any
  comercial_kw4: any
  comercial_kw5: any
  comercial_kw6: any
  comercial_statesQuotations: any
  comercial_statesInstallations: any
  comercial_state1: any
  comercial_state2: any
  comercial_state3: any
  comercial_state4: any
  comercial_state5: any
  comercial_state6: any
  comercial_load: boolean = false;
  num_panels: number

  // Enviroment:
  enviroment_tree_saving: any
  enviroment_co2_ton: any
  enviroment_km_equivalence: any
  enviroment_kmEquivalence: any
  enviroment_chartInstallations: any
  enviroment_total_energy_seller: any
  enviroment_leads_count: any
  enviroment_co2_inst: any
  enviroment_load: boolean = false;
  enviroment_tree_target: any
  enviroment_co2_target: any
  enviroment_km_target: any


  // Operative
  operative_leads_kw: any
  operative_list_kw_leads_in_process: any
  operative_percent_rating_installer: any
  operative_percent_rating_satisfaction: any
  operative_verificate_leads: any
  operative_is_global_user: any
  operative_add: any
  operative_vtr_percent: any
  operative_confirmed_percent: any
  operative_installing_percent: any
  operative_interconnecting_percent: any
  operative_total_time_states: any
  operative_total_time_days: any
  operative_installation_time_states: any
  operative_installation_time_days: any
  operative_cfe_time_states: any
  operative_cfe_time_days: any
  operative_load: boolean = false;
  operative_vtr_cd_percent: any


  // Monitoring
  monitoring_previous_month_value: any
  monitoring_month_numbers: any
  monitoring_month_energies: any
  monitoring_total_energy_seller: any
  monitoring_last_30_days_data: any
  monitoring_max_value: any
  monitoring_seller_date_joined: any
  monitoring_load: boolean = false;
  monitoring_fecha_inicio_seller: any

  // validation leads
  validation_load: any = false
  verificate_leads: any
  verificate_completed: any
  installation_vtr: any
  installation_vtr_cd: any
  installation_confirmed: any
  installation_in_process: any
  installation_interconnecting: any



    is_global_user: boolean
    clients: any
    installation_completed: any
    tree_saving : any
    km_equivalence : any
    co2_ton : any
    kw_install : any
    kw_produced : any
    // leads : any
    leads_kw: any
    client_dates : any
    list_kw_month : any
    current_month : any
    leads_count : any
    state : any
    leads_by_state: any
    coords_lead: any
    installations_in_progress: any;
    installations_in_sales_procces: any;
    leads_kw_list: any
    leads_state_kw: any
    co2_inst: any
    name1 : any
    name2 : any
    name3 : any
    name4 : any
    name5 : any
    name6 : any
    kw1 : any
    kw2 : any
    kw3 : any
    kw4 : any
    kw5 : any
    kw6 : any
    state1 : any
    state2 : any
    state3 : any
    state4 : any
    state5 : any
    state6 : any
    seller_email : any
    seller_first_name : any
    seller_last_name : any
    seller_ref_code : any
    seller_phone : any
    seller_state : any
    seller_country : any
    seller_date_joined : any
    percent_rating_installer : any
    percent_rating_satisfaction : any
    operative_vtr : any
    operative_confirmed : any
    operative_installing : any
    operative_interconnecting : any
    current_month_data : any
    last_month_data : any
    last_30_days_data : any
    total_kw_current_month: any
    total_kw_last_month : any
    total_time_states : any
    total_time_days : any
    installation_time_states : any
    installation_time_days : any
    cfe_time_states: any
    cfe_time_days: any
    months_number : any
    month_energies : any
    total_energy: any
    token: any
    total_energy_seller: any
    oportunities: any
    previous_month_value:any

    ClearDataService(): void {
      this.comercial_load = false;
      this.monitoring_load = false;
      this.operative_load = false;
      this.enviroment_load = false;
      this.validation_load = false;


    }


  constructor() {  }
}
